import { TABLET_BREAKPOINT_PX } from "common/variables";

/* Evaluate if a question's conditional logic is satisfied */
export const evaluateConditionalQuestion = (conditional, briefAnswers) => {
  const { question, values, operator } = conditional;
  const answer = (briefAnswers || {})[question];

  if (!answer) {
    return false;
  }

  /* Handle array answers (e.g. multi-select) and single values */
  const answerArray = Array.isArray(answer) ? answer : [answer];
  const answerIncludesValue = (v) => answerArray.includes(v);
  /* Evaluate based on operator */
  if (operator === "any") {
    return values.some(answerIncludesValue);
  } else if (operator === "all") {
    return values.every(answerIncludesValue);
  } else if (operator === "none") {
    return !values.some(answerIncludesValue);
  }

  return false;
};

/* Get brief questions that should be visible. */
export const getVisibleBriefQuestions = (allQuestions, briefAnswers) => {
  /* never show public description for PAP brief steps, since it's set in a different PAP section */
  const excluded = ["description"];

  return allQuestions.filter((q) => {
    // Exclude certain questions
    if (excluded.includes(q.name)) {
      return false;
    }

    // Check conditional logic
    if (q.conditional) {
      return evaluateConditionalQuestion(q.conditional, briefAnswers);
    }

    return true;
  });
};

/* Get a specific PAP URL given a set of parameters */
export const getPapUrl = (opts) => {
  const {
    step = "brief",
    subStep,
    projectId,
    categorySlug,
    subCategorySlug,
  } = opts;
  const baseUrl = "/start-a-project";
  if (step === "brief") {
    if (projectId) {
      return `${baseUrl}/${projectId}/${step}/${subStep}/`;
    }
    return `${baseUrl}/${categorySlug}/${subCategorySlug}/${step}/${subStep}/`;
  } else if (step === "details") {
    return `${baseUrl}/${projectId}/${step}/${subStep}/`;
  } else {
    return `${baseUrl}/${projectId}/${step}/`;
  }
};

export const showAllQuestionsAtOnce = () => {
  return window.innerWidth > TABLET_BREAKPOINT_PX;
};
